import React, { lazy } from "react";
import {
  Route,
  Redirect,
  Switch,
  useLocation
} from "react-router-dom";
import { connect } from 'react-redux';
import LeftSidebar from '../../components/left_side_bar';
import { motion } from "framer-motion";
import AuthCheck from '../../routes/auth_check';
import Menu from './menu';
import { ROUTES_PATH_CONFIG } from '../../config/routes';


const DashboardDefault = lazy(() => import('./dashboard'));
const VendorProfile = lazy(() => import('./profile'));
const Rates = lazy(() => import('./rates'));
const AllPosts = lazy(() => import('./posts/all'));
const AppliedPosts = lazy(() => import('./posts/applied'));
const Rfqs = lazy(() => import('./rfq'));
const MeetingInvites = lazy(() => import('./meeting_invites'));
const VendorSubscription = lazy(() => import('./subscription'));


function VendorRoute(props) {
  const location = useLocation();
  const {
    authData
  } = props;


  const user = authData.user ?
    authData.user : { role: "none" };

  return (<Route
    {...props}
    render={() => (
      <AuthCheck>
        <LeftSidebar userData={authData} menuContent={Menu[user.role]}>
          <Switch location={location} key={location.pathname}>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit="in"
              transition={{ duration: 1 }}>
              <Route
                path={ROUTES_PATH_CONFIG.VENDOR.dashboard}
                component={DashboardDefault}
              />

              <Route
                path={ROUTES_PATH_CONFIG.VENDOR.profile}
                component={VendorProfile}
              />

              <Route
                path={ROUTES_PATH_CONFIG.VENDOR.rates}
                component={Rates}
              />

              <Route
                path={ROUTES_PATH_CONFIG.VENDOR.all_posts}
                component={AllPosts}
              />

              <Route
                path={ROUTES_PATH_CONFIG.VENDOR.applied_posts}
                component={AppliedPosts}
              />

              <Route
                path={ROUTES_PATH_CONFIG.VENDOR.rfqs}
                component={Rfqs}
              />
              
              <Route
                path={ROUTES_PATH_CONFIG.VENDOR.meeting_invites}
                component={MeetingInvites}
              />

              
            <Route
              path={ROUTES_PATH_CONFIG.VENDOR.subscription}
              component={VendorSubscription}
            />

            </motion.div>
          </Switch>
        </LeftSidebar>
      </AuthCheck>
    )
    }
  />
  );
}

VendorRoute.defaultProps = {
  authData: {}
}

const mapStateToProps = state => ({
  authData: state.AUTH
});

export default connect(mapStateToProps)(VendorRoute);